import axios from 'axios'

import i18n from '@plugins/i18n'
import sdk from '@service/auth-sdk'
import ChunkUploadService from '@/src/service/chunk-upload-service'
const CHUNK_LIMIT_SIZE = 2 * 1024 * 1024
export default {
  namespaced: true,
  state: {
    isShowDialog: false,
    progressFiles: [],
    queue: {},
    configSend: {},
  },
  getters: {
    isShowDialog: (state) => state.isShowDialog,
    progressFiles: (state) => state.progressFiles,
    getProgressFileById: (state) => (id) => state.queue[id],
  },
  mutations: {
    showDialog(state) {
      state.isShowDialog = true
    },
    closeDialog(state) {
      state.isShowDialog = false
      state.progressFiles = []
      state.configSend = {}
    },
    setQueueUpload(state, file) {
      state.progressFiles.push(file)
      state.queue[file.id] = file
    },
    updateQueue(state, { id, queue }) {
      state.progressFiles = state.progressFiles.filter((x) => x.id != id)
      state.queue[id] = queue
      state.progressFiles.push(queue)
    },
    removeQueueUpload(state, id) {
      delete state.queue[id]
      state.progressFiles = state.progressFiles.filter((x) => x.id != id)
      if (!state.queue) {
        state.queue = {}
      }
    },
    setConfigSend(state, { id, config }) {
      state.configSend[id] = config
    },
  },
  actions: {
    // _UPLOAD_FILE
    async callUpload(
      { commit, dispatch },
      { url, data, option = {}, cbWhenComplete }
    ) {
      const file = data.get('file')

      if (file && file.size > CHUNK_LIMIT_SIZE) {
        return dispatch('callChunkUpload', {
          url,
          data,
          option,
          cbWhenComplete,
        })
      }

      commit('showDialog')

      const id = new Date().getTime()
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()

      const file_temp = {
        id,
        name:
          data.get('name') ||
          data.get('fileName') ||
          (file && file.name) ||
          'Đang tải dữ liệu',
        type: data.get('type') || '',
        progress: 0,
        isDone: false,
        isError: false,
        error_message: '',
        error: null,
        cancel: () => source.cancel('Hủy tải'),
      }

      const { headers = {}, ...restOption } = option

      const config = {
        method: 'post',
        url,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          ...headers,
        },
        cancelToken: source.token,
        cbWhenComplete,
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )

            commit('updateQueue', {
              id,
              queue: {
                ...file_temp,
                progress,
              },
            })
          }

          if (typeof restOption.onUploadProgress === 'function') {
            restOption.onUploadProgress(progressEvent)
          }
        },
        ...restOption,
      }

      commit('setConfigSend', { id, config })
      commit('setQueueUpload', file_temp)
      dispatch('upload', { id })

      return { id, queue: file_temp }
    },
    async callChunkUpload(
      { commit },
      { url, data, option = {}, cbWhenComplete }
    ) {
      commit('showDialog')

      const id = new Date().getTime()
      const file = data.get('file')

      const file_temp = {
        id,
        name:
          data.get('name') ||
          data.get('fileName') ||
          (file && file.name) ||
          'Đang tải dữ liệu',
        type: data.get('type') || '',
        progress: 0,
        isDone: false,
        isError: false,
        error_message: '',
        error: null,
        statusMessage: '',
        failedChunks: [],
        cancel: null,
      }

      commit('setQueueUpload', file_temp)

      const syncQueue = (patch = {}) => {
        commit('updateQueue', {
          id,
          queue: {
            ...file_temp,
            ...patch,
          },
        })

        Object.assign(file_temp, patch)
      }

      const uploadService = new ChunkUploadService({
        state: file_temp,

        onComplete: async (chunkData) => {
          try {
            syncQueue({
              progress: 100,
              statusMessage: 'Đang lưu dữ liệu...',
            })

            const formData = new FormData()

            for (const [key, value] of data.entries()) {
              if (key !== 'file') {
                formData.append(key, value)
              }
            }

            formData.append('file_path', chunkData && chunkData.path)
            formData.append('file_name', file ? file.name : '')

            const res = await sdk.request({
              method: 'post',
              url,
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              ...option,
            })

            syncQueue({
              progress: 100,
              isDone: true,
              isError: false,
              error_message: '',
              error: null,
              statusMessage: 'Hoàn thành',
            })

            if (cbWhenComplete) {
              cbWhenComplete(res)
            }

            return res
          } catch (error) {
            syncQueue({
              isDone: true,
              isError: true,
              error_message: 'Lưu dữ liệu sau khi upload chunk thất bại',
              error,
            })

            return null
          }
        },
        onProgress: (uploadState) => {
          syncQueue(uploadState)
        },

        onError: (message) => {
          syncQueue({
            isDone: true,
            isError: true,
            error_message: message || 'Tập tin tải lên lỗi',
          })
        },
      })

      file_temp.cancel = () => uploadService.cancelUpload()

      syncQueue({
        cancel: file_temp.cancel,
      })

      uploadService.startUpload(file)

      return { id, queue: file_temp }
    },
    // _CANCEL_UPLOAD
    async cancelUpload({ state }, { id }) {
      const file = state.queue[id]
      if (file && !file.isDone && file.cancel) {
        file.cancel()
      }
    },
    async cancelAll({ state }) {
      state.progressFiles
      for (const queueID in state.queue) {
        const file = state.queue[queueID]
        if (file && !file.isDone && file.cancel) {
          file.cancel()
        }
      }
      state.queue = {}
      state.isShowDialog = false
      state.progressFiles = []
    },
    // _REUPLOAD
    async reUpload({ dispatch, commit, state }, { id }) {
      const oldConfig = state.configSend[id]
      const oldFile_temp = state.progressFiles.find((x) => x.id == id)
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      const config = {
        ...oldConfig,
        cancelToken: source.token,
      }
      const file_temp = {
        ...oldFile_temp,
        isDone: false,
        isError: false,
        cancel: () => source.cancel(),
      }
      commit('setConfigSend', { id, config })
      commit('setQueueUpload', file_temp)
      commit('updateQueue', { id, queue: file_temp })
      dispatch('upload', { id })
    },
    // _UPLOAD
    async upload({ dispatch, state, commit }, { id }) {
      const config = state.configSend[id]
      const file_temp = state.queue[id]
      try {
        const res = await sdk.request(config)
        if (config.cbWhenComplete) {
          config.cbWhenComplete(res)
        }
      } catch (error) {
        file_temp.isError = true
        if (!axios.isCancel(error) || error.code != 'ECONNABORTED') {
          if (
            error.response.status == 400 &&
            error.response.data &&
            error.response.data.message
          ) {
            file_temp.error_message = error.response.data.message
          } else file_temp.error_message = 'Tập tin tải lên lỗi'
          file_temp.error = error
        } else {
          file_temp.error_message = 'Hủy tải'
        }
      } finally {
        file_temp.isDone = true
      }
      commit('updateQueue', { id, queue: file_temp })
    },
  },
}
